var _excluded = ["title", "subtitle", "asideLinks", "setIsAccountActive"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { memo } from "react";
import PlainLinkAtm from "../../../../../atoms/PlainLinkAtm";
import TextAtm from "../../../../../atoms/TextAtm";
import DropdownLinksOrg from "../../common/DropdownLinksOrg";
import DropdownOrg from "../../common/DropdownOrg";
function AccountDropdownOrg(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    asideLinks = _ref.asideLinks,
    setIsAccountActive = _ref.setIsAccountActive,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var handleAsideLinkClick = function handleAsideLinkClick(onClick) {
    return function (event) {
      setIsAccountActive(false);
      if (onClick) {
        onClick(event);
      }
    };
  };
  return /*#__PURE__*/React.createElement(DropdownOrg, _extends({
    main: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextAtm, {
      typography: "medium2_s",
      pushSpace: 0.5
    }, title), /*#__PURE__*/React.createElement(TextAtm, {
      typography: "nano1",
      emphasis: "medium"
    }, subtitle)),
    aside: /*#__PURE__*/React.createElement(DropdownLinksOrg, {
      links: asideLinks.map(function (asideLink) {
        return /*#__PURE__*/React.createElement(PlainLinkAtm, {
          to: asideLink.to,
          href: asideLink.href,
          title: asideLink.title,
          typography: "small2",
          emphasis: "medium",
          type: "opacity",
          onClick: handleAsideLinkClick(asideLink.onClick),
          hasCover: true
        }, asideLink.text);
      })
    })
  }, restProps));
}
export default /*#__PURE__*/memo(AccountDropdownOrg);